<template>
  <div>
    <div class="wrapper">
      <breadcrumb
        :crumbs="[$t('reports.omsSalePerformance'), $t('text.lineItem')]"
      >
      </breadcrumb>
    </div>
    <div class="wrapper table-area">
      <sticky
        :sticky-top="50"
        :viewport="1024"
        :is-rem="false"
        style="min-height: 52px"
      >
        <vxe-toolbar ref="recordsToolbar" zoom class="table-toolbar">
          <template v-slot:buttons>
            <el-button type="default" size="mini" @click="download">
              {{ $t("action.download") }}
            </el-button>
          </template>
        </vxe-toolbar>
      </sticky>
      <vxe-table
        :data="records"
        @checkbox-change="setSelected"
        @checkbox-all="setSelected"
        @sort-change="sortRecords"
        :sort-config="{ remote: true }"
        :checkbox-config="{ reserve: true }"
        :custom-config="{ storage: true, checkMethod: checkColumnMethod }"
        ref="recordsTable"
        class="recordsTable"
        size="mini"
        id="pendingsTable"
        row-id="id"
        :loading="loading"
        resizable
        round
        highlight-hover-row
        auto-resize
        :scroll-y="{ enabled: false }"
      >
        <vxe-table-column
          field="images"
          :title="$t('product.images')"
          width="85"
        >
          <template v-slot="{ row }">
            <thumbnail :images="row.images"></thumbnail>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="serialNo"
          :title="$t('order.serialNo')"
          min-width="130"
        >
          <template v-slot="{ row }">
            <small v-if="row.hurry" class="red">
              ({{ $t("order.hurrySimple") }})
            </small>
            {{ row.serialNo }}
            <div class="font10">{{ row.innerSerialNo }}</div>
            <state-label
              :state="row.workflowState"
              :permit="Permit.canActions('orderDealView')"
            >
              <span v-if="Permit.canActions('orderDealView')">{{
                $t("orderStates." + row.workflowState)
              }}</span>
              <span v-else>{{
                $t("orderStatesNoPermit." + row.workflowState)
              }}</span>
            </state-label>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerType"
          :title="$t('menu.customers')"
          min-width="80"
        >
          <template v-slot="{ row }">
            {{ row.customerName }}
            <div v-if="row.customerType != null" class="font10">
              {{ $t("customerTypes." + row.customerType) }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="customerCity"
          :title="$t('tenant.city')"
          min-width="70"
        >
          <template v-slot="{ row }">
            {{ row.customerCity }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productNo"
          :title="$t('product.productNo')"
          min-width="100"
          sortable
        >
          <template v-slot="{ row }">
            {{ row.productNo }}
            <small
              v-if="
                row.customerProductNo != null && row.customerProductNo != ''
              "
              >({{ row.customerProductNo }})</small
            >
            <div class="font10">
              {{ row.categoryName }}
              <span v-if="row.productBrand != null">/</span>
              {{ row.productBrand }}
            </div>
            <div class="font10">{{ row.color }} {{ row.size }}</div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="remark"
          :title="$t('text.remark')"
          min-width="100"
        >
          <template v-slot="{ row }">
            <div v-if="row.dealSuggest != null" class="red">
              <raw-html-limit-number :content="row.dealSuggest" :number="12" />
            </div>
            <div>
              <raw-html-limit-number
                :content="row.remark"
                :number="12"
                type="richText"
              />
            </div>
            <div>
              <attribute :content="row.specJson" :number="12" />
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="productPrice"
          :title="$t('order.salePrice')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.productPrice }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="price"
          :title="$t('order.price')"
          min-width="80"
        >
          <template v-slot="{ row }">
            <currency :code="row.currency"></currency>
            {{ row.price }}
            <small v-if="row.discountRate != null && row.discountRate != 0"
              >({{ row.discountRate }}%)</small
            >
            <div
              v-if="row.extraCharge != null && row.extraCharge != 0"
              class="font10"
            >
              {{ $t("order.extraChargeSimple") }}:
              <currency :code="row.currency"></currency>
              {{ row.extraCharge }}
            </div>
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="quantity"
          :title="$t('text.quantity')"
          width="60"
        >
          <template v-slot="{ row }">
            {{ row.quantity }}{{ row.unit }}
          </template>
        </vxe-table-column>
        <vxe-table-column
          field="handOverAt"
          :title="$t('text.handOverAt')"
          width="110"
          sortable
        ></vxe-table-column>

        <vxe-table-column
          field="ownerName"
          :title="$t('text.owner')"
          min-width="80"
        ></vxe-table-column>
        <vxe-table-column
          field="createAt"
          :title="$t('text.createAt')"
          width="110"
        />
      </vxe-table>
      <div class="flex flex-between pager">
        <div class="selected-qty-tips">
          <!-- 选中了
          <span class="strong">{{ selectRecordQty }} </span>条记录 -->
        </div>
        <div>
          <vxe-pager
            size="small"
            :loading="false"
            :background="false"
            :current-page="pager.currentPage"
            :page-size="pager.pageSize"
            :total="pager.total"
            :layouts="pagerConfig.layouts"
            :page-sizes="pagerConfig.pageSizes"
            @page-change="changePager"
          ></vxe-pager>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { page, table } from "@/utils/mixins.js";
import RawHtml from "@/components/RawHtml";
import Currency from "@/components/Currency";
import Order from "@/api/order.js";

export default {
  mixins: [
    page,
    table.pager,
    table.narrow,
    table.search,
    table.checker,
    table.sorter,
    table.basic,
  ],
  components: {
    RawHtml,
    Currency,
  },

  data() {
    return {
      searchForm: {},
      sorter: {
        sortBy: "orders_id",
        sortIndicator: "desc",
      },
      sorterMap: {
        productNo: "orders_productNo",
        handOverAt: "orders_handOverAt",
      },
      // saleSearchCount: null,
    };
  },
  created() {
    const self = this;
    self.searchForm = self.$route.query;
  },
  methods: {
    //
    download() {
      const self = this;
      if (self.records.length == 0) {
        this.$message({
          message: self.$t("text.noData"),
          type: "warning",
        });
        return;
      }
      Order.salesRevenueReportSaleDetailExportExcel(self.searchForm).then(
        function (res) {
          if (res.status === 200) {
            self.$message({
              message: self.$t("prompt.downloadPrompt"),
              type: "success",
            });
            self.checkedRows = [];
            self.$eventHub.$emit("emitDownLoad");
          } else {
            self.$message.error(self.$t("prompt.downloadErr"));
          }
        }
      );
    },
    //======
    dataProvider(params) {
      return Order.salesRevenueReportSaleDetail(params);
    },
  },
};
</script>
